const url = 'programas-fiplan';
class ProgramaIntegracaoService {
    async pesquisar(paginate) {
        const res = await window.$http.get(`${url}/find-list`, paginate.getParams());
        return res?.data ?? [];
    }
}

export default new ProgramaIntegracaoService();
